import { Box, CircularProgress } from "@material-ui/core";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useTokenParsed } from "store/auth/auth-store";

export default function PrivateRoutes() {
  const { keycloak, initialized } = useKeycloak();
  const { setTokenParsed } = useTokenParsed();

  const navigate = useNavigate();

  useEffect(() => {
    if (initialized && !keycloak?.authenticated) {
      navigate("/auth/login", {
        replace: true,
        state: { from: window.location.pathname },
      });
    }

    if (initialized && keycloak?.authenticated) {
      if (
        keycloak?.hasRealmRole("Access Disabled") &&
        !keycloak?.hasRealmRole("stratesys")
      ) {
        navigate("/access-disabled", {
          replace: true,
          state: { from: window.location.pathname },
        });
      }

      keycloak?.tokenParsed?.subscriptionAttributes
        ? setTokenParsed(keycloak?.tokenParsed)
        : navigate("/blocked");
    }
  }, [initialized, keycloak?.authenticated]);

  return keycloak?.authenticated ? (
    <Outlet />
  ) : (
    <Box minHeight="100vh" justifyContent="center" alignItems="center">
      <CircularProgress />
    </Box>
  );
}
